import { defineComponent, h } from 'vue'
import { mapState } from 'vuex'

export default (component: any) => defineComponent({
  computed: {
    ...mapState({
      presentation: (state: any) => state.presentation,
      questions: (state: any) => state.questions,
    }),
  },
  render() {
    return h(component, {
      ...this.$attrs,
      presentation: this.presentation,
      questions: this.questions,
    })
  },
})
